module.exports = __webpack_public_path__ + "img/choice.2cfdf8c8.svg";